import { render, staticRenderFns } from "./FooterErrors.vue?vue&type=template&id=61f60bae&scoped=true&"
import script from "./FooterErrors.vue?vue&type=script&lang=js&"
export * from "./FooterErrors.vue?vue&type=script&lang=js&"
import style0 from "./FooterErrors.vue?vue&type=style&index=0&id=61f60bae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f60bae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
